'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumInformation = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM7.99754 5.5C8.53754 5.503 8.99354 5.054 8.99954 4.511C9.00654 3.966 8.54254 3.5 7.99554 3.5C7.46254 3.5 7.00454 3.955 6.99954 4.487C6.99554 5.044 7.44054 5.497 7.99754 5.5ZM8.00005 6.79999C8.38665 6.79999 8.70005 7.11339 8.70005 7.49999V11.5C8.70005 11.8866 8.38665 12.2 8.00005 12.2C7.61345 12.2 7.30005 11.8866 7.30005 11.5V7.49999C7.30005 7.11339 7.61345 6.79999 8.00005 6.79999Z",
            fill: "currentColor"
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsxs("g", {
                    clipPath: "url(#clip0_103_1153)",
                    children: [
                        jsxRuntime.jsx("circle", {
                            cx: "8",
                            cy: "8",
                            r: "7.3",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeLinejoin: "round"
                        }),
                        jsxRuntime.jsx("path", {
                            d: "M8 11.5V7.5",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        jsxRuntime.jsx("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M7.9976 5.5C7.4406 5.497 6.9956 5.044 6.9996 4.487C7.0046 3.955 7.4626 3.5 7.9956 3.5C8.5426 3.5 9.0066 3.966 8.9996 4.511C8.9936 5.054 8.5376 5.503 7.9976 5.5Z",
                            fill: "currentColor"
                        })
                    ]
                }),
                jsxRuntime.jsx("defs", {
                    children: jsxRuntime.jsx("clipPath", {
                        id: "clip0_103_1153",
                        children: jsxRuntime.jsx("rect", {
                            width: "16",
                            height: "16",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};

module.exports = MediumInformation;
